module.exports = __webpack_public_path__ + "img/main-active.d50cbb53.svg";